var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 4.64286V1.85714C15.1111 1.3646 14.9121 0.892226 14.5579 0.543944C14.2036 0.195663 13.7232 0 13.2222 0H3.77778C3.27681 0 2.79637 0.195663 2.44213 0.543944C2.0879 0.892226 1.88889 1.3646 1.88889 1.85714V4.64286C1.38792 4.64286 0.907478 4.83852 0.553243 5.1868C0.199007 5.53508 0 6.00745 0 6.5V11.1429H1.25611L1.88889 13H2.83333L3.46611 11.1429H13.5339L14.1667 13H15.1111L15.7439 11.1429H17V6.5C17 6.00745 16.801 5.53508 16.4468 5.1868C16.0925 4.83852 15.6121 4.64286 15.1111 4.64286ZM3.77778 1.85714H13.2222V4.64286H3.77778M15.1111 9.28571H1.88889V6.5H15.1111V9.28571Z",
    fill: "#848585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.614e31da1ad070c9082ef7118833c612.svg";
export { ForwardRef as ReactComponent };